export default __webpack_public_path__ + "static/media/logoWork.6c69c430.png";